import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import * as React from 'react'
import styled from '@emotion/styled'
import IconText from '../../atoms/IconText'
import { Course } from 'types/course'
// import { secondsToHours } from 'helpers/secondsToHms'
import { colors, fontFamilies } from '@configs/styles/config'
import { useCartAndWishList } from '@contexts/CartAndWishList'
import VideoPlayIcon from '@public/static/icons/video-play-icon'
import { useTranslation } from 'react-i18next'
import IfOwnedCourse from '@components/atoms/IfOwnedCourse/IfOwnedCourse'
import { Skeleton } from '@nextui-org/react-latest'
import dynamic from 'next/dynamic'
import { BottomNotification, CenterNotification } from '@type/main'
const PopUpCenter = dynamic(() => import('@components/organisms/PopUpCenter'))
const PopUpBottom = dynamic(() => import('@components/organisms/PopUpBottom'))
import ReactPlayer from 'react-player'
import useWindowDimensions from '@hooks/useWindowDimensions'
import { calculateCourseTime } from '@utils/calculateCourseTime'
import Image from 'next/image'
import CloseIcon from '@public/static/icons/toast/CloseIcon'
import { TimeAmountIcon } from '@public/static/icons/time-amount-icon'
import LecturesQtyIcon from '@public/static/icons/lectures-qty-icon'
import InfinityIcon from '@public/static/icons/infinity-icon'
import CertificateIcon from '@public/static/icons/certificate-icon'
const DiscountBlock = dynamic(() => import('./components/DiscountBlock'), {
  ssr: false,
})
const BuyBlock = dynamic(import('./components/BuyBlock'), {
  loading: () => (
    <div>
      <Skeleton className="h-[3rem] w-full rounded-full bg-default-200 mb-2" />
      <Skeleton className="h-[3rem] w-full rounded-full bg-default-200" />
    </div>
  ),
  ssr: false,
})

const VideoPlayer = dynamic(() => import('@components/organisms/VideoPlayer'), {
  ssr: false,
})

type StickyCoursePageBlockProps = {
  course: Course
  totalTime: number
  totalLectures: number
  isPreview: boolean
  setShowCheckoutModal: Function
  exitPreview: () => void
  setShowPresentationalVideo: Dispatch<SetStateAction<boolean>>
  openShareModal: () => void
  buyNow: Function
  exitPreviewBtnRef?: any
  isInPreview?: boolean
}

const StickyCoursePageBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #1a1e3d;
  border-radius: 15px;
  box-shadow: -10px 10px 20px 10px rgba(0, 0, 0, 0.05);
  position: -webkit-sticky;
  position: sticky;
  top: 1rem;
  z-index: 2;
  padding: 32px 32px 64px 32px;
  box-sizing: border-box;
  background-color: ${colors.uguWhite};
`

const VideoPlayerWrapper = styled.div`
  width: 100%;
  position: relative;
  border-radius: 10px;
`
const PlayIconContainer = styled.div`
  display: flex;
  border-radius: 100%;
  width: 2.5rem;
  height: 2.5rem;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.3);
  z-index: 2;
`
const PlayIconWrapper = styled.div`
  position: relative;
  display: flex;
  :hover {
    cursor: pointer;
  }
`

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 11px;
  align-self: flex-end;
`

const Price = styled.div<{ active?: boolean }>`
  font-size: 1.5rem;
  text-decoration: ${(props) => (props.active ? '' : 'line-through')};
  color: ${(props) => (props.active ? colors.uguPurple : colors.uguGrey)};
  margin-left: 5px;
  font-family: ${(props) =>
    props.active ? fontFamilies.bold : fontFamilies.regular};
  letter-spacing: 0rem;
`

const WarrantyText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  font-family: ${fontFamilies.regular};
  font-size: 1.1rem;
  margin-top: 1rem;
`
const WhatIncludedText = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: bold;
  margin-top: 2rem;
  padding-left: 1rem;
`
const IconTextWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  height: 7rem;
  justify-content: space-between;
  padding-left: 1.5rem;
`

const TextButtonWrapper = styled.div`
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 44px;
  align-self: stretch;
`
const TextButton = styled.div`
  cursor: pointer;
  font-size: 15px;
  color: #1a1e3d;
  text-decoration-line: underline;
`

const StickyCoursePageBlock: React.FunctionComponent<
  StickyCoursePageBlockProps
> = (props) => {
  const {
    course,
    totalTime,
    isPreview,
    exitPreview,
    setShowCheckoutModal,
    openShareModal,
    buyNow,
    exitPreviewBtnRef,
    isInPreview,
  } = props

  const { discounts } = useCartAndWishList()
  const { t } = useTranslation(['common', 'stickyCoursePageBlock', 'cart'])
  const [showCoupon, setShowCoupon] = useState<boolean>(false)
  const [playVideo, setPlayVideo] = useState(false)
  const [centerNotification, setCenterNotification] = useState<
    boolean | CenterNotification
  >(false)
  const [bottomNotification, setBottomNotification] = useState<
    boolean | BottomNotification
  >(false)
  const [videoControlsState, setVideoControlsState] = useState(false)
  const { width } = useWindowDimensions()
  const videoTempRef = useRef<ReactPlayer>(null)
  const fullScreenHandlerRef = useRef<() => void>(null)
  const [temDiscount, setTemDiscount] = useState<any>(null)

  useEffect(() => {
    const discount = discounts.find(
      (discount) =>
        discount.courses &&
        [course._id].some((courseId) => discount.courses.includes(courseId))
    )
    if (discount) setTemDiscount(discount)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isInPreview && playVideo) {
      setPlayVideo(false)
    }
  }, [isInPreview, playVideo])

  const getResoursesCount = () => {
    if (!course?.course_materials) return 0
    let count = 0
    course?.course_materials.sections?.forEach((s) => {
      s?.lectures?.forEach((l) => {
        count += l?.resources?.length || 0
      })
    })
    return count
  }

  const handlePlayVideo = () => {
    if (videoTempRef.current) {
      videoTempRef.current.getInternalPlayer().play()
      setPlayVideo(true)
    }
  }

  const controlsState = (state: boolean) => {
    setVideoControlsState(state)
  }

  return (
    <StickyCoursePageBlockWrapper>
      <VideoPlayerWrapper>
        {course?.presentationalVideo?.public?.url && !playVideo && (
          <PlayIconContainer>
            <button
              onClick={handlePlayVideo}
              aria-label="Play"
              className="bg-transparent"
            >
              <PlayIconWrapper>
                <VideoPlayIcon width="100%" />
              </PlayIconWrapper>
            </button>
          </PlayIconContainer>
        )}
        {course?.presentationalImage && (
          <span className={playVideo ? 'hidden' : 'inline'}>
            {/* <CoursePosterImage
              src={course?.presentationalImage}
              alt={course?.title}
              loading="lazy"
            /> */}
            <Image
              src={course?.presentationalImage}
              width={375}
              height={175}
              alt={course?.title || 'Course'}
              className="bg-uguDarkBrightPurple/80 w-full object-cover aspect-video rounded-xl"
            />
          </span>
        )}
        {course.presentationalVideo?.public?.url && (width || 0) >= 1050 && (
          <span className={playVideo ? 'inline relative' : 'hidden'}>
            <VideoPlayer
              videoURL={course.presentationalVideo?.public?.url}
              videoName={''}
              isMultipleVideos={false}
              nextLectureTitle={undefined}
              previousLectureTitle={undefined}
              isModal={true}
              showReplayButton={false}
              showWideScreen={false}
              height=""
              hideSettings={true}
              videoTempRef={videoTempRef}
              controlsState={controlsState}
              fullScreenHandlerRef={
                fullScreenHandlerRef as React.MutableRefObject<
                  () => void | null
                >
              }
            >
              {videoControlsState ? (
                <button
                  className="absolute z-10 top-3 right-3 bg-transparent"
                  onClick={() => {
                    if (videoTempRef.current) {
                      setPlayVideo(false)
                      videoTempRef.current.getInternalPlayer().pause()
                      fullScreenHandlerRef.current?.()
                    }
                  }}
                >
                  <CloseIcon className="text-white text-xl" />
                </button>
              ) : (
                <></>
              )}
            </VideoPlayer>
          </span>
        )}
      </VideoPlayerWrapper>
      <PriceWrapper>
        <Price active>
          {course?.price
            ? course?.salePrice
              ? `$${course?.salePrice / 100}`
              : `$${course?.price / 100}`
            : 'Free'}
        </Price>
        {course?.salePrice &&
          course?.price &&
          course?.salePrice < course?.price && (
            <>
              <Price active>/</Price>
              <Price>${course?.price / 100}</Price>
            </>
          )}
      </PriceWrapper>
      <BuyBlock
        buyNow={buyNow}
        course={course}
        exitPreview={exitPreview}
        setShowCheckoutModal={setShowCheckoutModal}
        temDiscount={temDiscount}
        exitPreviewBtnRef={exitPreviewBtnRef}
        isPreview={isPreview}
      />
      <IfOwnedCourse hide id={course._id}>
        <WarrantyText>
          {t('30DaysMoneyBackGuarantee', { ns: 'stickyCoursePageBlock' })}
        </WarrantyText>
      </IfOwnedCourse>
      <WhatIncludedText>
        {t('whatsInlcuded', { ns: 'stickyCoursePageBlock' })}
      </WhatIncludedText>
      <IconTextWrapper>
        <IconText
          icon={<TimeAmountIcon />}
          text={
            calculateCourseTime(totalTime) +
            (calculateCourseTime(totalTime) > 1
              ? t('hofVideoContent', { ns: 'stickyCoursePageBlock' })
              : t('hofVideoContent', { ns: 'stickyCoursePageBlock' }))
          }
          fontSize={'1rem'}
          marginBetween="1rem"
          opacity="1"
        ></IconText>
        <IconText
          icon={<LecturesQtyIcon color={colors.uguBrightPurple} />}
          text={
            `${getResoursesCount()} ` +
            (getResoursesCount() > 1
              ? t('downloadableresources', { ns: 'stickyCoursePageBlock' })
              : t('downloadableresources', { ns: 'stickyCoursePageBlock' }))
          }
          marginBetween="1rem"
          opacity="1"
          fontSize={'1rem'}
        ></IconText>
        <IconText
          icon={<InfinityIcon />}
          text={t('lifetimeAccess', { ns: 'stickyCoursePageBlock' })}
          marginBetween="1rem"
          opacity="1"
          fontSize={'1rem'}
        ></IconText>
        <IconText
          icon={<CertificateIcon />}
          text={t('completionCertificate', { ns: 'stickyCoursePageBlock' })}
          opacity="1"
          marginBetween="1rem"
          fontSize={'1rem'}
        ></IconText>
      </IconTextWrapper>
      {!showCoupon && (
        <TextButtonWrapper>
          <TextButton
            onClick={() => {
              if (isPreview) return
              setShowCoupon((prev) => !prev)
            }}
            style={{ opacity: isPreview ? '0.3' : '1' }}
          >
            {t('applyCoupon', { ns: 'stickyCoursePageBlock' })}
          </TextButton>
          <TextButton
            style={{ opacity: isPreview ? '0.3' : '1' }}
            onClick={() => (isPreview ? {} : openShareModal())}
          >
            {t('sharetheCourse', { ns: 'stickyCoursePageBlock' })}
          </TextButton>
        </TextButtonWrapper>
      )}
      {showCoupon && (
        <DiscountBlock
          course={course}
          setBottomNotification={setBottomNotification}
          setCenterNotification={setCenterNotification}
          setShowCoupon={setShowCoupon}
          setTemDiscount={setTemDiscount}
          temDiscount={temDiscount}
        />
      )}

      {centerNotification && (
        <PopUpCenter
          centerNotification={centerNotification as CenterNotification}
          showPopUp={centerNotification as boolean}
        />
      )}
      {bottomNotification && (
        <PopUpBottom
          bottomNotification={bottomNotification as BottomNotification}
          setShowPopUp={setBottomNotification}
        />
      )}
    </StickyCoursePageBlockWrapper>
  )
}

export default StickyCoursePageBlock
